<template>
  <v-dialog class="rounded-lg" @update:model-value="closeModal" :model-value="modelValue" max-width="700" persistent>
    <v-card>
      <div
        class="d-flex justify-end align-center pt-3 pr-3"
      >
        <div @click="closeModal" @keydown="closeModal" class="cursor-pointer">
          <IconMaterial color="#64748b" icon="close" :size="24" />
        </div>
      </div>
      <div class="px-8 pb-8">
        <div class="bold-headline-h4-sm mb-3">Enhance Your Fund's Visibility!</div>
        <div class="regular-body-md mb-3 pl-3">
          <li>
            <span class="bold-body-md">AI Revolution in Fund Selection: </span>Allocators have universally
            embraced our new AI tool, which allows for more
            effective fund discovery through natural language queries. This is not just an option; it's the future of how
            allocators will search for funds. Opt in to include
            <span class="bold-body-md">only documents visible on your profile</span> and
            profile information (e.g., fund description) in this AI-enhanced search.
          </li>
        </div>
        <div class="mb-3 pl-3">
            <li><span class="bold-body-md">Critical Warning for Non-Participants: </span>
              <span class="regular-body-md">
                Don't miss out on this opportunity to stand out and connect
                with allocators in a more impactful way.
              </span>
            </li>
        </div>
        <div class="regular-body-md mb-3 pl-3">
            <li>
              <span class="bold-body-md">Data Security and Privacy: </span>
              This functionality operates within our strict
              <a class="nowrap" href="https://iconnections.io/terms/" target="_blank">Terms of Use</a>, with
              your security as a priority. Explore our
              <a href="https://help.iconnections.io/en/articles/10296670-ai-tool-faq-for-managers" target="_blank">FAQ</a> to
              understand how this can significantly elevate your fund's visibility and engagement.
            </li>
        </div>
        <div class="d-flex justify-center mb-6">
          <img
            src="https://assets.iconnections.io/images/ai_diagram.png"
            alt="ai_diagram"
            style="height: 303px; width: 541px; border-radius: 12px;"
          />
        </div>
        <div class="d-flex mb-3 justify-center">
          <Button class="margin-right_xs-df" text="Yes, include my company" @click="onOptInClick(true)"/>
          <Button variant="secondary" text="No, not at this time" @click="onOptInClick(false)"/>
        </div>
        <div class="text-center regular-body-sm typography_light">
          By opting in, all funds visible on your profile will be included in the AI tool
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script setup>

import {
  defineProps, defineEmits,
} from 'vue';
import IconMaterial from '@design_system_v3/components/atoms/IconMaterial.vue';
import Button from '@design_system_v3/components/atoms/Button.vue';
import { updateAiOptIn } from '@common/services/aip';

defineProps({
  modelValue: Boolean,
});

const emits = defineEmits(['update:modelValue']);

const onOptInClick = async (optedIn) => {
  await updateAiOptIn(optedIn).then(() => {
    emits('update:modelValue', false);
  }).catch(() => {
    window.postMessage({
      name: 'iConnectionsEventBus',
      type: 'showSnackbar',
      message: 'An error has occurred',
      snackbarType: 'error',
    }, '*');
  });
};

const closeModal = () => {
  localStorage.setItem('date-ai-modal-shown', new Date());
  emits('update:modelValue', false);
};
</script>

<style scoped lang="scss">
@import '@foundation';

.nowrap {
  white-space: nowrap;
}

</style>
